import React from 'react';
import { useTranslation } from 'react-i18next';

const AccountPlayersPreviewHeader = () => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        <th>{t('accountPlayersPreview.columns.id')}</th>
        <th>{t('accountPlayersPreview.columns.name')}</th>
        <th>{t('accountPlayersPreview.columns.cohort')}</th>
        <th>{t('accountPlayersPreview.columns.ageRange')}</th>
        <th>{t('accountPlayersPreview.columns.createdAt')}</th>
        <th>{t('accountPlayersPreview.columns.type')}</th>
      </tr>
    </thead>
  );
}

export default AccountPlayersPreviewHeader;
